import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';
import { ChevronDown } from 'lucide-react';
import { useEffect, useState } from 'react';

interface timeZoneProps {
  options: {
    value: string[];
    label: string;
  }[];
  onChange?: (text: string) => void;
  placeholder?: string;
  className?: string;
  value?: string;
}

export const AvailabilityTimezone: React.FC<timeZoneProps> = ({ options, value, onChange }) => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const matchedOption = (timezone: string) => {
    return options.find((tz) => tz.value.includes(timezone));
  };

  const [selectedTimezone, setSelectedTimezone] = useState('');
  const [label, setSelectedLabel] = useState('');

  useEffect(() => {
    if (value) {
      const option = matchedOption(value);
      if (option) {
        setSelectedLabel(option?.label);
        setSelectedTimezone(option?.value[0]);
      }
    } else if (userTimezone) {
      const option = matchedOption(userTimezone);
      if (option) {
        setSelectedLabel(option?.label);
        setSelectedTimezone(option?.value[0]);
      }
    } else {
      setSelectedLabel('Select Timezone');
      setSelectedTimezone('');
    }
    return () => {};
  }, [value, userTimezone]);

  const handleTimezoneChange = (newValue: string, label: string) => {
    setSelectedTimezone(newValue);
    setSelectedLabel(label);
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        {/* <Button
          variant='secondary'
          className='w-full h-[60px] justify-start gap-2 rounded-[11px] bg-transparent border px-4 py-6 overflow-hidden text-lg'
          id='availability-timezone'
        >
          <span className='text-[12px]'>Timezone</span>
          <span className='font-medium text-[14px] flex'>{label}</span>
          <ChevronDown />
        </Button> */}
        <Button
          id='combobox-trigger'
          variant='outline'
          role='combobox'
          className='relative w-full h-[61px] justify-between bg-transparent hover:bg-transparent hover:text-white '
        >
          {value && <p className='absolute top-2 left-4 text-xs text-textSecondary'>Timezone</p>}
          <p className='pt-4 font-normal w-full overflow-hidden'>{label}</p>
          <ChevronDown className='ml-2 h-4 w-4 shrink-0 opacity-50' />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className=' h-96 overflow-auto' align='start'>
        {options.map((tz, index) => (
          <DropdownMenuCheckboxItem
            key={index}
            onCheckedChange={() => handleTimezoneChange(tz.value[0], tz.label)}
            defaultValue={selectedTimezone}
            className={cn(tz.label === label ? 'bg-bgSecondary' : '')}
          >
            {tz.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
